import { endpoints } from '../api/endpoints';
import { queryKeys } from './queryKeys';
import { queryConfig } from './queryConfig';
import { createListQueryHook } from './queryFactory';

export const useSubscribes = createListQueryHook({
  queryKey: queryKeys.subscribes(),
  endpoint: endpoints.subscribes,
  config: {
    staleTime: queryConfig.staleTime.short,
  },
});

